







































import Vue from 'vue';

export default Vue.extend({
  name: 'Confirmar',
  data() {
    return {
      dialog: false,
      titulo: '',
      mensagem: '',
      resolve: () => {},
      reject: () => {},
    };
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (this.dialog === true) {
        if (e.key === 'Enter') {
          this.confirma();
        } else if (e.key === 'Escape') {
          this.cancela();
        }
      }
    });
  },
  methods: {
    async open(titulo: string, mensagem: string) {
      this.dialog = true;
      this.titulo = titulo;
      this.mensagem = mensagem;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirma() {
      this.resolve(true);
      this.dialog = false;
    },
    cancela() {
      this.resolve(false);
      this.dialog = false;
    },
  },
});
